(function() {
  function formatPrice(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }
  
  function fetchCartTotal(callback) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && typeof data.total_price === 'number') {
          callback(formatPrice(data.total_price));
        }
      })
      .catch(function() {});
  }
  
  function updateButton(priceText) {
    var labels = document.querySelectorAll('[data-cart-checkout-label]');
    labels.forEach(function(label) {
      var newText = 'COMMANDER · ' + priceText;
      if (label.textContent.trim() !== newText) {
        label.textContent = newText;
      }
    });
    
    // Fallback: botões sem o span data-cart-checkout-label
    var buttons = document.querySelectorAll('button[name="checkout"], .cart__checkout');
    buttons.forEach(function(btn) {
      if (btn.querySelector('[data-cart-checkout-label]')) return; // já tratado acima
      var hasIcon = btn.querySelector('svg, img');
      var newText = 'COMMANDER · ' + priceText;
      if (hasIcon) {
        // Preserva ícone, só altera nós de texto
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null, false);
        var first = null, node;
        while (node = walker.nextNode()) {
          if (node.nodeValue.trim()) { first = node; break; }
        }
        if (first && first.nodeValue.trim() !== newText) {
          first.nodeValue = newText;
          // Limpa outros nós de texto
          while (node = walker.nextNode()) {
            if (node.nodeValue.trim()) node.nodeValue = '';
          }
        }
      } else if (btn.textContent.trim() !== newText) {
        btn.textContent = newText;
      }
    });
  }
  
  function refresh() {
    fetchCartTotal(updateButton);
  }
  
  // 1. Corrida inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  
  // 2. Quando o drawer abre / fecha / carrinho muda
  document.addEventListener('theme:cart-drawer:open', refresh);
  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:cart:refresh', refresh);
  document.addEventListener('theme:product:added', refresh);
  
  // 3. MutationObserver: vigia mudanças no DOM e atualiza
  var debounceTimer;
  var observer = new MutationObserver(function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 150);
  });
  
  function startObserver() {
    var target = document.querySelector('cart-drawer, #cart-drawer, [data-cart-form]') || document.body;
    observer.observe(target, { childList: true, subtree: true, characterData: true });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();